module.exports = __webpack_public_path__ + "static/bluemuslin-7b5922c2b24a343700ec814ed28de8da.jpeg";